import { computed, MaybeRef, toValue } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { whenAuthenticatedAnd } from '@/utils/query-utils'
import { ComponentType } from '@/configuration/component/component-types'

export const useTransformerGeneralCommentsQuery = (transformerId: MaybeRef<string | undefined>) => {
    return useQuery({
        queryKey: ['transformers', transformerId, 'generalComments'],
        queryFn: async ({ signal }) => {
            const {
                data: { result },
            } = await hcaClientFactory.generalCommentsApi.getGeneralComments(toValue(transformerId) ?? '', ComponentType.Transformer, {
                signal,
            })
            return result?.generalComments?.sort((a, b) => {
                if (!a.createdAt || !b.createdAt) {
                    return 0
                }
                const aDate = a.updatedAt ? a.updatedAt : a.createdAt
                const bDate = b.updatedAt ? b.updatedAt : b.createdAt
                return new Date(bDate).getTime() - new Date(aDate).getTime()
            })
        },
        enabled: whenAuthenticatedAnd(computed(() => !!toValue(transformerId))),
    })
}
